import React from "react";
import {MdHourglassEmpty} from "react-icons/md";
import moment from "moment";
import OpenPopulationStatusModal from "./OpenPopulationStatusModal";

interface Props {}
interface State {
  isModalOpen: boolean;
  isClickedFloor : string;
}

export default class PlaceFloatingPopulationDetail extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isModalOpen: false,
      isClickedFloor: '만든 라면',
    };
  }
  renderFloorStatus = (_thisFloor) => {
    return (
      <div className={"card-container"} style={{flex: "unset", width: "45%", height: 138, margin: "10px 12px"}} onClick={() => this.openPopulationStatus(_thisFloor)}>
        <div className={"txt card-title"}>
          {_thisFloor}
        </div>
        <div style={{height: 20}}/>

        <div className={"txt"} style={{fontSize: 28, textAlign: "center"}}>
          {Math.round(Math.random() * 500)}<span style={{fontSize: 20}}>명</span>
          <span style={{fontSize: 17, margin: "0 10px", color: "#FFFFFF90"}}>/</span>
          보통
        </div>
        <div style={{height: 15}}/>

        <div className={'txt'} style={{alignItems: "center", justifyContent: "center", display: "flex"}}>
          <MdHourglassEmpty  color={"#50C9C3"} />
          <span style={{fontSize: 12}}>최근 동작 감지 시간: <span style={{fontSize: 11, color: "#FFFFFF90"}}>18h : 17m : 20s</span></span>
        </div>
      </div>
    )
  }

  openPopulationStatus = (_onClickedFloor) => {
    this.setState({ 
      isClickedFloor: _onClickedFloor,
      isModalOpen: true 
    });
  }
  closePopulationStatus = () => {
    this.setState({ isModalOpen: false });
  }

  render() {
    return (
      <div style={{height: "calc(100% - 520px)"}}>
        <div className={"header row"} style={{alignItems: "flex-end"}}>
          {/* 2. ToDo : 실시간 유동인구 상세현황 창이 떠야함 */}
          <div className={"txt title"}>실시간 유동인구 상세 현황</div>
          <div style={{fontSize: 13, color: "#8088A0"}}>
            ※ People Counting Sensor data
          </div>
        </div>

        <div style={{display: "flex", flexWrap: "wrap", padding: "0 12px", overflowY: "auto", maxHeight: "calc(100% - 20px)", cursor: 'pointer'}}>
          {this.renderFloorStatus("지하 2층 인원수")}
          {this.renderFloorStatus("지하 1층 인원수")}
          {this.renderFloorStatus("지상 1층 인원수")}
          {this.renderFloorStatus("지상 2층 인원수")}
          {this.renderFloorStatus("지상 3층 인원수")}
          {this.renderFloorStatus("지상 4층 인원수")}
        </div>

        <div className={"row"} style={{padding: "5px 36px 0 24px"}}>
          <div />
          <div style={{fontSize: 13, color: "#8088A0"}}>
            ※ {moment().format("YYYY년 MM월 DD일 HH:mm:ss")}
          </div>
        </div>
        {this.state.isModalOpen && (
          <OpenPopulationStatusModal 
            clickedFloor = {this.state.isClickedFloor}
            closePopulationStatus={this.closePopulationStatus} 
          />
        )}
      </div>
    );
  }
}
